<template>
  <!--
      作者 kmdshop
      时间：2024年
      描述：设置-商家入驻码设置
  -->
  <div class="merchant-qrcode-setting">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--商家入驻码设置-->
      <div class="common-form">商家入驻码设置</div>
      
      <el-form-item label="商家入驻码" prop="merchant_qrcode">
        <div class="qrcode-upload-area">
          <!-- 显示二维码 -->
          <div v-if="form.merchant_qrcode.file_path" class="qrcode-preview">
            <div class="image-box">
              <img :src="form.merchant_qrcode.file_path" alt="商家入驻码" class="qrcode-img">
              <div class="qrcode-info">
                <p>商家入驻二维码</p>
                <p class="upload-time" v-if="form.update_time">
                  更新于: {{ formatTime(form.update_time) }}
                </p>
              </div>
              <!-- <a href="javascript:void(0);" class="delete-btn" @click="deleteQrcode">
                <i class="el-icon-delete"></i>
              </a> -->
            </div>
            
            <div class="qrcode-actions">
              <el-button type="primary" size="small" @click="downloadQrcode">
                <i class="el-icon-download"></i> 下载二维码
              </el-button>
              <el-button type="warning" size="small" @click="previewQrcode">
                <i class="el-icon-view"></i> 预览
              </el-button>
              <el-button type="success" size="small" @click="handlePrint">
                <i class="el-icon-printer"></i> 批量打印
              </el-button>
              <!-- <el-button size="small" @click="showUploadDialog">
                <i class="el-icon-refresh"></i> 更换二维码
              </el-button> -->
            </div>
          </div>
          
          <!-- 上传区域 -->
          <!-- <div v-else class="upload-area" @click="showUploadDialog">
            <div class="upload-content">
              <i class="el-icon-upload"></i>
              <p class="upload-text">点击上传商家入驻二维码</p>
              <p class="upload-tips">建议尺寸：300×300px，支持jpg、png格式</p>
            </div>
          </div> -->
        </div>
        
        <!-- <div class="setting-tips">
          <h4>设置说明：</h4>
          <ul>
            <li>1. 商家可通过扫描此二维码进入入驻申请页面</li>
            <li>2. 建议使用清晰、易于扫描的二维码图片</li>
            <li>3. 二维码内容应为商家入驻页面的URL链接</li>
            <li>4. 上传后可在移动端测试扫码效果</li>
          </ul>
        </div> -->
      </el-form-item>
      
      <!-- <el-form-item label="入驻链接地址" prop="merchant_url">
        <el-input 
          v-model="form.merchant_url" 
          placeholder="请输入商家入驻页面链接地址" 
          class="max-w460"
        >
          <template slot="append">
            <el-button @click="copyUrl" type="text">
              <i class="el-icon-document-copy"></i> 复制
            </el-button>
          </template>
        </el-input>
        <div class="tips">注：此链接将用于生成商家入驻二维码</div>
      </el-form-item> -->
      
      <!-- <el-form-item label="是否启用" prop="is_enabled">
        <el-switch 
          v-model="form.is_enabled" 
          active-text="启用" 
          inactive-text="禁用"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
        <div class="tips">注：禁用后商家将无法通过二维码申请入驻</div>
      </el-form-item> -->
      
      <!--提交-->
      <!-- <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" >
          <i class="el-icon-check"></i> 保存设置
        </el-button>
        <el-button @click="resetForm">
          <i class="el-icon-refresh-left"></i> 重置
        </el-button>
        <el-button type="info" @click="goBack">
          <i class="el-icon-back"></i> 返回
        </el-button>
      </div> -->
    </el-form>
    
    <!--二维码上传组件-->
    <Upload 
      v-if="showUpload" 
      :config="{ total: 1, accept: 'image/*' }" 
      :isupload="showUpload" 
      @returnImgs="handleQrcodeUpload"
      @closeDialog="closeUploadDialog"
    >
      上传二维码
    </Upload>
    
    <!--二维码预览对话框-->
    <el-dialog 
      title="二维码预览" 
      :visible.sync="previewDialogVisible" 
      width="30%"
      center
      :before-close="closePreviewDialog"
    >
      <div class="preview-content" v-if="form.merchant_qrcode.file_path">
        <img :src="form.merchant_qrcode.file_path" alt="商家入驻码预览" class="preview-img">
        <p class="preview-tips">请用手机扫描此二维码</p>
        <!-- <div class="preview-info">
          <p>链接地址：</p>
          <p class="url-text">{{ form.merchant_url || '未设置链接地址' }}</p>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePreviewDialog">关闭</el-button>
        <el-button type="primary" @click="downloadQrcode">下载</el-button>
      </span>
    </el-dialog>
    
    <!-- 打印内容 -->
    <div id="print-container" style="display: none;">
      <div class="print-qrcode-container">
        <div class="print-qrcode-item" v-if="form.merchant_qrcode.file_path">
          <img :src="form.merchant_qrcode.file_path" alt="商家入驻码" class="print-qrcode-img">
          <p class="print-qrcode-text">商家入驻二维码</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js'
import Upload from "@/components/file/Upload"

export default {
  components: {
    Upload,
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*是否显示上传对话框*/
      showUpload: false,
      /*是否显示预览对话框*/
      previewDialogVisible: false,
      /*form表单数据*/
      form: {
        merchant_qrcode: {
          file_id: '',
          file_path: '',
          file_name: ''
        },
        merchant_url: '',
        is_enabled: true,
        update_time: '',
        create_time: ''
      },
      /*原始数据，用于重置*/
      originalForm: null
    }
  },
  created() {
    this.getSettingData()
  },
  methods: {
    /*获取商家入驻码设置数据*/
    getSettingData() {
      this.loading = true
      SettingApi.getMerchantQrcode({}, true)
        .then(res => {
          this.loading = false
          if (res.code === 1 && res.data) {
            this.form = {
              merchant_qrcode: res.data.vars.values.merchant_qrcode || {
                file_id: '',
                file_path: '',
                file_name: ''
              },
              merchant_url: res.data.merchant_url || '',
              is_enabled: res.data.is_enabled !== undefined ? res.data.is_enabled : true,
              update_time: res.data.update_time || '',
              create_time: res.data.create_time || ''
            }
            // 保存原始数据用于重置
            this.originalForm = JSON.parse(JSON.stringify(this.form))
          } else {
            this.$message.warning(res.msg || '获取设置数据失败')
          }
        })
        .catch(error => {
          this.loading = false
          console.error('获取商家入驻码设置失败:', error)
          this.$message.error('获取设置失败，请重试')
        })
    },
    
    /*提交设置*/
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 验证二维码是否上传
          if (!this.form.merchant_qrcode.file_path) {
            this.$message.warning('请先上传商家入驻二维码')
            return
          }
          
          // 注释掉链接验证，因为你现在不需要链接
          // // 验证链接地址是否填写
          // if (!this.form.merchant_url.trim()) {
          //   this.$message.warning('请输入商家入驻链接地址')
          //   return
          // }
          
          // // 验证链接格式
          // const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
          // if (!urlRegex.test(this.form.merchant_url)) {
          //   this.$message.warning('请输入正确的链接地址')
          //   return
          // }
          
          this.loading = true
          SettingApi.saveMerchantQrcode(this.form, true)
            .then(res => {
              this.loading = false
              if (res.code == 1) {
                this.$message.success('设置保存成功')
                // 更新本地数据
                this.getSettingData()
              } else {
                this.$message.error(res.msg || '保存失败')
              }
            })
            .catch(error => {
              this.loading = false
              console.error('保存设置失败:', error)
              this.$message.error('保存失败，请重试')
            })
        }
      })
    },
    
    /*重置表单*/
    resetForm() {
      if (this.originalForm) {
        this.form = JSON.parse(JSON.stringify(this.originalForm))
        this.$message.info('表单已重置')
      } else {
        this.form = {
          merchant_qrcode: {
            file_id: '',
            file_path: '',
            file_name: ''
          },
          merchant_url: '',
          is_enabled: true,
          update_time: '',
          create_time: ''
        }
      }
    },
    
    /*返回上一页*/
    goBack() {
      this.$router.go(-1)
    },
    
    /*显示上传对话框*/
    showUploadDialog() {
      this.showUpload = true
    },
    
    /*关闭上传对话框*/
    closeUploadDialog() {
      this.showUpload = false
    },
    
    /*处理二维码上传 - 修复版 */
    handleQrcodeUpload(e) {
      if (e && e.length > 0) {
        const file = e[0]
        
        console.log('上传的文件信息:', file) // 添加日志查看数据结构
        
        // 方法1: 根据文件路径判断文件类型
        const filePath = file.file_path || file.url || ''
        const extension = this.getFileExtension(filePath).toLowerCase()
        
        // 允许的文件扩展名
        const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif']
        
        if (!allowedExtensions.includes(extension)) {
          this.$message.error('请上传图片格式的文件 (jpg, jpeg, png, gif)')
          return
        }
        
        // 方法2: 如果存在文件类型字段，也检查一下
        if (file.file_type) {
          const allowedMimeTypes = [
            'image/jpeg',
            'image/jpg',
            'image/png',
            'image/gif',
            'image/pjpeg', // IE的jpeg类型
            'image/x-png'  // IE的png类型
          ]
          
          if (!allowedMimeTypes.includes(file.file_type.toLowerCase())) {
            this.$message.error('文件类型不支持，请上传图片格式')
            return
          }
        }
        
        // 验证文件大小（限制5MB）
        const maxSize = 5 * 1024 * 1024 // 5MB
        if (file.file_size && file.file_size > maxSize) {
          this.$message.error('图片大小不能超过5MB')
          return
        }
        
        // 如果file_size不存在，使用其他方式判断大小
        if (!file.file_size) {
          // 可以根据需要添加其他大小判断逻辑
          console.warn('文件大小信息缺失')
        }
        
        this.form.merchant_qrcode = {
          file_id: file.file_id || file.id || '',
          file_path: file.file_path || file.url || '',
          file_name: file.file_name || file.name || '商家入驻码'
        }
        
        this.$message.success('二维码上传成功')
      }
      this.closeUploadDialog()
    },
    
    /*删除二维码*/
    deleteQrcode() {
      this.$confirm('确定要删除商家入驻二维码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.merchant_qrcode = {
          file_id: '',
          file_path: '',
          file_name: ''
        }
        this.$message.success('二维码已删除')
      }).catch(() => {})
    },
    
    /*下载二维码*/
    downloadQrcode() {
      if (!this.form.merchant_qrcode.file_path) {
        this.$message.warning('请先上传二维码')
        return
      }
      
      // 创建一个虚拟链接进行下载
      const link = document.createElement('a')
      link.href = this.form.merchant_qrcode.file_path
      
      // 从文件路径获取文件名，如果没有则使用默认名
      const filePath = this.form.merchant_qrcode.file_path
      let fileName = this.form.merchant_qrcode.file_name || '商家入驻码'
      const extension = this.getFileExtension(filePath)
      
      // 确保文件名有扩展名
      if (extension && !fileName.endsWith('.' + extension)) {
        fileName = fileName + '.' + extension
      }
      
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      this.$message.success('二维码下载开始')
    },
    
    /*获取文件扩展名*/
    getFileExtension(filename) {
      if (!filename) return ''
      const parts = filename.split('.')
      if (parts.length > 1) {
        return parts.pop().toLowerCase()
      }
      return ''
    },
    
    /*预览二维码*/
    previewQrcode() {
      if (!this.form.merchant_qrcode.file_path) {
        this.$message.warning('请先上传二维码')
        return
      }
      this.previewDialogVisible = true
    },
    
    /*关闭预览对话框*/
    closePreviewDialog() {
      this.previewDialogVisible = false
    },
    
    /*复制链接地址*/
    copyUrl() {
      if (!this.form.merchant_url) {
        this.$message.warning('请先填写链接地址')
        return
      }
      
      // 使用clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.form.merchant_url)
          .then(() => {
            this.$message.success('链接地址已复制到剪贴板')
          })
          .catch(err => {
            console.error('复制失败:', err)
            this.fallbackCopyText(this.form.merchant_url)
          })
      } else {
        this.fallbackCopyText(this.form.merchant_url)
      }
    },
    
    /*降级复制方法*/
    fallbackCopyText(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('链接地址已复制到剪贴板')
        } else {
          this.$message.error('复制失败，请手动复制')
        }
      } catch (err) {
        console.error('复制失败:', err)
        this.$message.error('复制失败，请手动复制')
      }
      
      document.body.removeChild(textarea)
    },
    
    /*格式化时间*/
    formatTime(timestamp) {
      if (!timestamp) return '--'
      try {
        // 如果是字符串时间，直接返回
        if (typeof timestamp === 'string' && timestamp.includes('-')) {
          return timestamp
        }
        
        // 如果是数字时间戳
        const time = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp
        const date = new Date(time * 1000)
        
        // 检查日期是否有效
        if (isNaN(date.getTime())) {
          return '--'
        }
        
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
      } catch (error) {
        console.error('格式化时间失败:', error)
        return '--'
      }
    },
    
    /*批量打印功能*/
    handlePrint() {
      if (!this.form.merchant_qrcode.file_path) {
        this.$message.warning('请先上传二维码')
        return
      }
      
      const printContent = document.getElementById("print-container").cloneNode(true)
      
      const printWindow = window.open("")
      printWindow.document.write(`
        <html>
          <head>
            <style>
              body {
                font-family: Arial, sans-serif;
                margin: 0px;
                padding: 20px;
              }
              .print-qrcode-container {
                display: flex;
                flex-wrap: wrap;
                gap: 20px;
                justify-content: center;
              }
              .print-qrcode-item {
                text-align: center;
                padding: 20px;
                border: 1px solid #eee;
                border-radius: 8px;
                width: 200px;
              }
              .print-qrcode-img {
                width: 150px;
                height: 150px;
                margin-bottom: 10px;
              }
              .print-qrcode-text {
                margin: 0;
                font-size: 14px;
                color: #333;
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `)
      printWindow.document.close()
      printWindow.print()
    }
  }
}
</script>
<style scoped lang="scss">
.merchant-qrcode-setting {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
}

.common-form {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.max-w460 {
  max-width: 460px;
}

.tips {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.qrcode-upload-area {
  max-width: 500px;
}

.qrcode-preview {
  .image-box {
    position: relative;
    display: flex;
    align-items: center;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px dashed #dcdfe6;
    margin-bottom: 15px;
    
    .qrcode-img {
      width: 120px;
      height: 120px;
      border-radius: 4px;
      margin-right: 20px;
      border: 1px solid #eee;
    }
    
    .qrcode-info {
      flex: 1;
      
      p {
        margin: 0 0 10px 0;
        color: #333;
        font-size: 14px;
        
        &.upload-time {
          color: #999;
          font-size: 12px;
        }
      }
    }
    
    .delete-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 24px;
      height: 24px;
      background: #ff4d4f;
      border-radius: 50%;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        background: #ff7875;
        transform: scale(1.1);
      }
      
      i {
        font-size: 14px;
      }
    }
  }
  
  .qrcode-actions {
    display: flex;
    gap: 10px;
    
    .el-button {
      flex: 1;
    }
  }
}

.upload-area {
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #fafafa;
  
  &:hover {
    border-color: #409eff;
    background: #f0f7ff;
    
    .upload-content {
      i, .upload-text {
        color: #409eff;
      }
    }
  }
  
  .upload-content {
    i {
      font-size: 48px;
      color: #c0c4cc;
      margin-bottom: 15px;
      transition: color 0.3s;
    }
    
    .upload-text {
      font-size: 16px;
      color: #606266;
      margin-bottom: 10px;
      transition: color 0.3s;
    }
    
    .upload-tips {
      font-size: 12px;
      color: #999;
    }
  }
}

.setting-tips {
  margin-top: 15px;
  padding: 15px;
  background: #f0f9ff;
  border-radius: 4px;
  border-left: 4px solid #409eff;
  
  h4 {
    margin: 0 0 10px 0;
    color: #333;
    font-size: 14px;
  }
  
  ul {
    margin: 0;
    padding-left: 20px;
    
    li {
      color: #666;
      font-size: 13px;
      line-height: 1.6;
      margin-bottom: 5px;
    }
  }
}

.preview-content {
  text-align: center;
  
  .preview-img {
    width: 200px;
    height: 200px;
    margin: 0 auto 20px;
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 10px;
    background: white;
  }
  
  .preview-tips {
    color: #666;
    margin-bottom: 15px;
  }
  
  .preview-info {
    text-align: left;
    background: #f5f5f5;
    padding: 15px;
    border-radius: 4px;
    word-break: break-all;
    
    p {
      margin: 0 0 5px 0;
      font-weight: bold;
      color: #333;
    }
    
    .url-text {
      color: #409eff;
      font-size: 13px;
      font-weight: normal;
    }
  }
}

.common-button-wrapper {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  
  .el-button {
    margin-right: 10px;
  }
}

@media (max-width: 768px) {
  .qrcode-preview {
    .image-box {
      flex-direction: column;
      text-align: center;
      
      .qrcode-img {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }
    
    .qrcode-actions {
      flex-direction: column;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/setting/supply_code/index.vue